document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('product-search');
  const suggestionsContainer = document.getElementById('suggestions');
  const resultsContainer = document.getElementById('search-results');
  const searchButton = document.getElementById('search-button');
  let manualUrls = {};

  // Load manual_url.json and store the URLs in manualUrls
  fetch('https://cdn.shopify.com/s/files/1/0830/5721/3754/files/manual_url.json?v=1716452621')
    .then(response => response.json())
    .then(data => {
      manualUrls = data;
    })
    .catch(error => console.error('Error loading manual_url.json:', error));

  searchInput.addEventListener('input', function() {
    const query = searchInput.value;
    if (query.length > 0) {
      fetch(`/search/suggest.json?q=${query}&resources[type]=product`)
        .then(response => response.json())
        .then(data => {
          suggestionsContainer.innerHTML = '';

          if (data.resources.results.products.length > 0) {
            data.resources.results.products.forEach(product => {
              const modelNumber = product.title;
              if (modelNumber) {
                const suggestionItem = document.createElement('div');
                suggestionItem.classList.add('suggestion-item');
                suggestionItem.textContent = modelNumber;
                suggestionItem.addEventListener('click', () => {
                  searchInput.value = modelNumber;
                  fetchProductDetails(modelNumber);
                  suggestionsContainer.innerHTML = '';
                });
                suggestionsContainer.appendChild(suggestionItem);
              }
            });
          } else {
            suggestionsContainer.innerHTML = '<p>No suggestions found</p>';
          }
        });
    } else {
      suggestionsContainer.innerHTML = '';
    }
  });

  searchButton.addEventListener('click', function() {
    suggestionsContainer.innerHTML = ''; 
    const query = searchInput.value;
    fetchProductDetails(query);
  });

  function fetchProductDetails(query) {
    fetch(`/search/suggest.json?q=${query}&resources[type]=product`)
      .then(response => response.json())
      .then(data => {
        resultsContainer.innerHTML = '';

        if (data.resources.results.products.length > 0) {
          data.resources.results.products.forEach(product => {
            const productItem = document.createElement('div');
            productItem.classList.add('search-result-item');
            console.log(product);
            const productHandle = product.handle;
            console.log('qwertyuiop',productHandle);

            // Get the manual URL from the manualUrls object
            const manualUrl = manualUrls[productHandle];
console.log('qfghp',manualUrls);
            productItem.innerHTML = `
              <img src="${product.featured_image.url}" alt="${product.title}">
              <h3>${product.title}</h3>
              <a href="${manualUrl}" class="download-button" download target="_blank">Download Manual</a>
            `;
            resultsContainer.appendChild(productItem);
          });
        } else {
          resultsContainer.innerHTML = '<p>No products found</p>';
        }
      });
  }
});